import { render } from "./LbrxHeader.vue?vue&type=template&id=86f76f28&scoped=true"
import script from "./LbrxHeader.vue?vue&type=script&lang=js"
export * from "./LbrxHeader.vue?vue&type=script&lang=js"

import "./LbrxHeader.vue?vue&type=style&index=0&id=86f76f28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f76f28"]])

export default __exports__